import { computed, effect, inject, Injectable, signal } from '@angular/core';

import { CallStoreService } from '../components/call/services/call-store.service';
import { isNetworkBad } from '../utils/device.util';
import { ZimService } from './zim.service';

@Injectable({ providedIn: 'root' })
export class UiStatusBarService {
  private callStore = inject(CallStoreService);
  private zimService = inject(ZimService);

  constructor() {
    // Cleanup phải đi qua tham số onCleanup: Angular KHÔNG dùng giá trị trả về
    // của effect, nên `return () => clearTimeout(...)` sẽ không bao giờ chạy và
    // timer 60s tích luỹ mỗi lần effect re-run.
    effect(
      (onCleanup) => {
        if (!this.canShowNotice()) {
          this.shouldShowNotice.set(true);
          return;
        }

        this.shouldShowNotice.set(false);
        const timeoutId = setTimeout(() => {
          if (this.canShowNotice()) {
            this.shouldShowNotice.set(true);
          }
        }, 60 * 1000);

        onCleanup(() => clearTimeout(timeoutId));
      },
      {
        allowSignalWrites: true,
      },
    );
  }

  readonly showStatusBar = computed(() => {
    const isCalling = this.callStore.showCallStatusBar();
    const networkBad = isNetworkBad(this.zimService.connectionState());
    return isCalling || networkBad;
  });

  private canShowNotice = computed(() => isNetworkBad(this.zimService.connectionState()));
  private shouldShowNotice = signal(true);

  showNotice = computed(() => this.canShowNotice() && this.shouldShowNotice());
}
